import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'
import { compose } from 'redux'

import { Nullable } from 'clickNgo/models/utils'
import { resetAllModifiedDataByKey } from 'cng-common/features/form'
import { fetchQbrMainData } from 'partner360/services/qbr/fetchQbrMainData'

import { QBR_SETTINGS_FORM_KEY } from '../../../components/QBR/components/qbrDocumentDetails/components/steps/settingsStep/components/qbrSettingsForm'
import { IFetchQbrDocumentResponse } from '../../../models/qbr/IFetchQbrDocumentResponse'
import { IQBRPartner } from '../../../models/qbr/IQBRPartners'
import { REQUEST_RESET_DATA } from '../constants'
import { changeQBRLastStep } from '../QBRSlice'
import { selectIsSelectedDocumentChanged, selectQBRLastStep } from '../selectors'

export interface IRequestResetDataResult {
  qbrDocument: IFetchQbrDocumentResponse
  partners: IQBRPartner[]
}

export const requestResetData = createAsyncThunk<Nullable<IRequestResetDataResult>, number>(
  REQUEST_RESET_DATA,
  async (documentId, { dispatch, getState }) => {
    const lastStep = compose(selectQBRLastStep, getState)()
    // This approach allows us to re-init QBR form because all initialization happens on the first page...
    dispatch(changeQBRLastStep(1))
    // ...before you return to `lastStep` page.
    await dispatch(resetAllModifiedDataByKey(QBR_SETTINGS_FORM_KEY))
    dispatch(changeQBRLastStep(lastStep))

    const hasSignificantChanges = compose(selectIsSelectedDocumentChanged, getState)()
    if (hasSignificantChanges) {
      return fetchQbrMainData({ documentId })
    }

    return null
  }
)
